import { styled } from "@mui/material/styles";
import { Swiper } from "swiper/react";

import prevIcon from "assets/images/leftArrowIcon.svg";
import nextIcon from "assets/images/rightArrowIcon.svg";

const StyledSwiper = styled(Swiper)(({ theme }) => ({
  ":root": {
    "--swiper-navigation-size": "30px",
  },
  "& .swiper-button-prev::after, .swiper-button-next::after": {
    height: 48,
    width: 48,
    fontSize: 0,
    boxShadow: "0 2px 3px 0 rgba(37,45,95,.25)",
    position: "absolute",
    background: "white",
    borderRadius: 40,
    zIndex: 10,
    cursor: "pointer",
    display: "flex",
    alignContent: "center",
    alignItems: "center",
    flexWrap: "nowrap",
    color: "rgba(0,0,0,.25)",
  },
  "& .swiper-button-prev::after": {
    content: `url("${prevIcon}")`,
    paddingLeft: 17,
  },
  "& .swiper-button-next::after": {
    content: `url("${nextIcon}")`,
    paddingLeft: 20,
  },
  "& .swiper-button-prev, .swiper-button-next": {
    display: "none",
    verticalAlign: "top",
    [theme.breakpoints.up("mobile")]: {
      display: "flex",
    },
  },
  "& .swiper-button-prev:hover::after, .swiper-button-next:hover::after": {
    "@media (hover: hover)": {
      background: "rgb(255 255 255 / 60%)",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.3)",
    },
  },
  "& .swiper-button-next": {
    marginRight: 20,
  },
  "& .swiper-button-prev": {
    marginLeft: 20,
  },
  "& .swiper-button-prev.swiper-button-disabled, & .swiper-button-next.swiper-button-disabled": {
    display: "none",
  },
  "& .swiper-slide img": {
    height: 168,
    [theme.breakpoints.up("mobile")]: {
      height: 321,
    },
  },
  "& .swiper-slide": {
    width: "auto",
    display: "flex",
    alignItems: "baseline",
    minWidth: 112,
    cursor: "pointer",
    zIndex: 1,
  },
}));

export default StyledSwiper;
